import { render } from "./SecondSection.vue?vue&type=template&id=659e70ec&scoped=true"
import script from "./SecondSection.vue?vue&type=script&lang=ts"
export * from "./SecondSection.vue?vue&type=script&lang=ts"

import "./SecondSection.vue?vue&type=style&index=0&id=659e70ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-659e70ec"

export default script